<template>
  <li>
    <div
      class="step-link"
      :class="{
        'step-link-disabled': !submital.id || step.en == 'not found',
        'step-link-active': currentStep == step.en
      }"
      @click="$emit('step-link-clicked', step)"
    >
      <b-row align-h="around" align-v="center">
        <div class="step-image">
          <font-awesome-icon v-if="step.en == 'design'" :icon="['far', 'drafting-compass']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'dimensions'" :icon="['far', 'ruler-combined']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'conditions'" :icon="['far', 'wind']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'automation' || step.en == 'products'" :icon="['fas', 'cogs']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'electrical'" :icon="['fas', 'bolt']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'limitations'" :icon="['far', 'exclamation-triangle']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'general'" :icon="['far', 'info-circle']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'integrations'" :icon="['far', 'microchip']" size="2x" fixed-width />
          <font-awesome-icon v-else-if="step.en == 'network_details'" :icon="['far', 'network-wired']" size="2x" fixed-width />
          <!-- TODO: Change icons -->
          <font-awesome-icon v-else-if="step.en == 'door_type'" :icon="['far', 'exclamation-triangle']" size="2x" fixed-width />
          <img v-else :src="stepImage" class="step-link-image">
        </div>
        <div class="step-label">
          <span>{{ step.es | titleizePayrollType }}</span>
        </div>
        <div class="step-blanks text-center">
          <div v-if="blankCount > 0">
            <span>{{ blankCount }}</span>
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width class="text-warning" />
          </div>
        </div>
        <div class="step-alarms text-center">
          <div v-if="alarmCount > 0">
            <span>{{ alarmCount }}</span>
            <font-awesome-icon :icon="['fas', 'ban']" fixed-width class="text-danger" />
          </div>
        </div>
        <div class="step-arrow text-right">
          <font-awesome-icon :icon="['far', 'angle-right']" fixed-width />
        </div>
      </b-row>
    </div>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TrackImg from 'images/side_menu_icons/wizard_track.png'
import ComponentsImg from 'images/side_menu_icons/wizard_components.png'

export default {
  name: 'SubmitalShowStepLink',
  props: {
    step: Object
  },
  computed: {
    ...mapState ({
      submital: state => state.configurator.submital,
      currentStep: state => state.configurator.currentStep
    }),
    ...mapGetters(['submitalLocked']),
    stepImage () {
      switch (this.step.en) {
        case 'track':
          return TrackImg
        case 'components':
          return ComponentsImg
      }
    },
    blankCount () {
      if (!this.submital.id || !this.step) return 0
      return this.submital.blank_data[this.step.en] || 0
    },
    alarmCount () {
      if (!this.submital.id || !this.step) return 0
      if (this.submital.alarm_data[this.step.en]) {
        return this.submital.alarm_data[this.step.en].count
      }
      return 0
    }
  }
}
</script>

<style scoped>

.step-link {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  border: none;
  width: 100%;
  height: 100%;
  background-color: #fff;
  text-align: left;
  display: block;
  color: #000;
  text-decoration: none !important;
}
.step-label {
  width: 200px;
  font-family: 'Gill Sans', sans-serif;
  color: #163D7D;
  line-height: 2.25;
}
.step-blanks { width: 50px; }
.step-alarms { width: 50px; }
.row {
  padding: 0;
  margin: 0;
}
li { border-bottom: 1px solid #ccc; }
.step-link-image {
  left: 0;
  width: 40px;
}
i {
  line-height: 2.25;
  padding-left: 5px;
  color: #555;
}

.step-link:hover {
  opacity: 0.8;
  cursor: pointer;
}

.step-link-disabled {
  color: #aaa;
  background-color: #f2f2f2;
  pointer-events: none;
}

.step-link-disabled .step-label {
  color: #aaa;
}

.step-link-disabled .step-link-image {
  filter: grayscale(100%);
  opacity: 0.6;
}
.step-link-active {
  background-color: #163D7D;
  color: whitesmoke;
}
.step-link-active:hover {
  opacity: 0.8;
  background-color: #163D7D;
}
.step-link-active .step-link-image {
  color: whitesmoke;
}
.step-link-active .step-label {
  color: whitesmoke;
}
</style>
